import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-representativewise-taluka',
  // standalone: true,
  // imports: [],
  templateUrl: './representativewise-taluka.component.html',
  styleUrl: './representativewise-taluka.component.scss'
})
export class RepresentativewiseTalukaComponent implements OnInit {


 offrepwiseData;
  today = new Date();
  startDate = '';
  endDate = '';
  isLoading: boolean = false;
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
  ];
  totalth = 0;
  finalData = [];
  off_rep_name;
  appliedFilters: any = {};

  constructor(
    public dialogref: MatDialogRef<RepresentativewiseTalukaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {

    this.isLoading = true;
    this.offrepwiseData = this.data['offrepwisedata'];
    this.off_rep_name = this.data['off_rep_name'];
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    // console.log(this.offrepwiseData);

    this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);

    let data = this.uniqueData(this.offrepwiseData, (a) => a.subscription_type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
        this.subTypesName.push({
          name: data[i]['subscription_type'],
          isVisible: true,
        });
        // }
      }
    }

    // console.log(this.subTypesName);
    // this.totalth = this.subTypesName.length * 5 + 8;
    this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 8;

    // this.getoffdata();
    this.setData();

    throw new Error('Method not implemented.');
  }


   countryNameNew: any
  stateNameNew: any

  // Correct नूतनी-बाकी Column Calcultion 
// setData() {
//   this.finalData = [];
//   let finalTotal: any = {};

//   // Initialize grand total
//   this.subTypesName.forEach((b: any, i) => {
//     if (b.isVisible) {
//       let name = this.getKey(b.name);
//       finalTotal[name + '_एकूण'] = 0;
//       finalTotal[name + '_नवीन'] = 0;
//       finalTotal[name + '_नूतनीकरण'] = 0;
//       finalTotal[name + '_नूतनीकरणबाकी'] = 0;
//       if (i === 0) {
//         finalTotal['name'] = 'एकूण';
//         finalTotal['sub'] = 0;
//         finalTotal['एकूण'] = 0;
//         finalTotal['नवीन'] = 0;
//         finalTotal['नूतनीकरण'] = 0;
//         finalTotal['नूतनीकरणबाकी'] = 0;
//       }
//     }
//   });

//   const repGroups = this.groupBy(this.offrepwiseData, 'rep_name');

//   Object.keys(repGroups).forEach(repName => {
//     const repData = repGroups[repName];
//     const districtGroups = this.groupBy(repData, 'district_name');

//     let repTotal: any = {};

//     // Initialize rep total
//     this.subTypesName.forEach((b: any, i) => {
//       if (b.isVisible) {
//         let name = this.getKey(b.name);
//         repTotal[name + '_एकूण'] = 0;
//         repTotal[name + '_नवीन'] = 0;
//         repTotal[name + '_नूतनीकरण'] = 0;
//         repTotal[name + '_नूतनीकरणबाकी'] = 0;
//         if (i === 0) {
//           repTotal['name'] = 'प्रतिनिधी एकूण - ' + repName;
//           repTotal['sub'] = 0;
//           repTotal['एकूण'] = 0;
//           repTotal['नवीन'] = 0;
//           repTotal['नूतनीकरण'] = 0;
//           repTotal['नूतनीकरणबाकी'] = 0;
//         }
//       }
//     });

//     let repShown = false;

//     Object.keys(districtGroups).forEach(district => {
//       const districtData = districtGroups[district];

//       const talukaGroups = this.groupBy(districtData, 'taluka');

//       let districtTotal: any = {};
//       // Initialize district total
//       this.subTypesName.forEach((b: any, i) => {
//         if (b.isVisible) {
//           let name = this.getKey(b.name);
//           districtTotal[name + '_एकूण'] = 0;
//           districtTotal[name + '_नवीन'] = 0;
//           districtTotal[name + '_नूतनीकरण'] = 0;
//           districtTotal[name + '_नूतनीकरणबाकी'] = 0;
//           if (i === 0) {
//             districtTotal['rep_name'] = repName;
//             districtTotal['district_name'] = district;
//             districtTotal['sub'] = 0;
//             districtTotal['एकूण'] = 0;
//             districtTotal['नवीन'] = 0;
//             districtTotal['नूतनीकरण'] = 0;
//             districtTotal['नूतनीकरणबाकी'] = 0;
//           }
//         }
//       });

//       // --- taluka wise loop ---
//       Object.keys(talukaGroups).forEach(taluka => {
//         const talukaData = talukaGroups[taluka];
//         let talukaTotal: any = {};

//         // Initialize taluka total
//         this.subTypesName.forEach((b: any, i) => {
//           if (b.isVisible) {
//             let name = this.getKey(b.name);
//             talukaTotal[name + '_एकूण'] = 0;
//             talukaTotal[name + '_नवीन'] = 0;
//             talukaTotal[name + '_नूतनीकरण'] = 0;
//             talukaTotal[name + '_नूतनीकरणबाकी'] = 0;
//             if (i === 0) {
//               talukaTotal['rep_name'] = repName;
//               talukaTotal['district_name'] = district;
//               // keep HTML compatibility: expose taluka value on 'rep_taluka'
//               talukaTotal['rep_taluka'] = taluka;
//               talukaTotal['sub'] = 0;
//               talukaTotal['एकूण'] = 0;
//               talukaTotal['नवीन'] = 0;
//               talukaTotal['नूतनीकरण'] = 0;
//               talukaTotal['नूतनीकरणबाकी'] = 0;
//             }
//           }
//         });

//         talukaData.forEach((a: any) => {
//           let name = this.getKey(a.subscription_type);
//           let today = new Date();
//           today.setMonth(today.getMonth() + 1);
//           let cutoffDate = formatDate(today, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');

//           if (a['sub_perid_to_date'] > cutoffDate) {
//             if (a.rcpt_type === 'New') {
//               talukaTotal[name + '_नवीन']++;
//               districtTotal[name + '_नवीन']++;
//               repTotal[name + '_नवीन']++;
//               finalTotal[name + '_नवीन']++;
//               talukaTotal['नवीन']++;
//               districtTotal['नवीन']++;
//               repTotal['नवीन']++;
//               finalTotal['नवीन']++;
//             }
//             if (a.rcpt_type === 'Renew') {
//               talukaTotal[name + '_नूतनीकरण']++;
//               districtTotal[name + '_नूतनीकरण']++;
//               repTotal[name + '_नूतनीकरण']++;
//               finalTotal[name + '_नूतनीकरण']++;
//               talukaTotal['नूतनीकरण']++;
//               districtTotal['नूतनीकरण']++;
//               repTotal['नूतनीकरण']++;
//               finalTotal['नूतनीकरण']++;
//             }

//             talukaTotal['sub']++;
//             districtTotal['sub']++;
//             repTotal['sub']++;
//             finalTotal['sub']++;

//             const amt = parseInt(a.total_amt) || 0;
//             talukaTotal[name + '_एकूण'] += amt;
//             districtTotal[name + '_एकूण'] += amt;
//             repTotal[name + '_एकूण'] += amt;
//             finalTotal[name + '_एकूण'] += amt;
//             talukaTotal['एकूण'] += amt;
//             districtTotal['एकूण'] += amt;
//             repTotal['एकूण'] += amt;
//             finalTotal['एकूण'] += amt;
//           } else {
//             talukaTotal[name + '_नूतनीकरणबाकी']++;
//             districtTotal[name + '_नूतनीकरणबाकी']++;
//             repTotal[name + '_नूतनीकरणबाकी']++;
//             finalTotal[name + '_नूतनीकरणबाकी']++;
//             talukaTotal['नूतनीकरणबाकी']++;
//             districtTotal['नूतनीकरणबाकी']++;
//             repTotal['नूतनीकरणबाकी']++;
//             finalTotal['नूतनीकरणबाकी']++;
//           }
//         });

//         talukaTotal['showRepName'] = !repShown;
//         repShown = true;
//         this.finalData.push({ ...talukaTotal, type: 'record' });
//       });

//       // push district total
//       districtTotal.type = 'districtTotal';
//       this.finalData.push(districtTotal);
//     });

//     // Push representative total
//     repTotal.type = 'repTotal';
//     this.finalData.push(repTotal);
//   });

//   // Push grand total
//   finalTotal.type = 'grandTotal';
//   this.finalData.push(finalTotal);
//   this.isLoading = false;
// }


// Remove नूतनी-बाकी Column Calculation 
// setData() {
//   this.finalData = [];
//   let finalTotal: any = {};

//   this.subTypesName.forEach((b: any, i) => {
//     if (b.isVisible) {
//       let name = this.getKey(b.name);
//       finalTotal[name + '_एकूण'] = 0;
//       finalTotal[name + '_नवीन'] = 0;
//       finalTotal[name + '_नूतनीकरण'] = 0;
//       finalTotal[name + '_नूतनीकरणबाकी'] = 0;
//       if (i === 0) {
//         finalTotal['name'] = 'एकूण';
//         finalTotal['sub'] = 0;
//         finalTotal['एकूण'] = 0;
//         finalTotal['नवीन'] = 0;
//         finalTotal['नूतनीकरण'] = 0;
//         finalTotal['नूतनीकरणबाकी'] = 0;
//       }
//     }
//   });

//   const repGroups = this.groupBy(this.offrepwiseData, 'rep_name');

//   Object.keys(repGroups).forEach(repName => {
//     const repData = repGroups[repName];
//     const districtGroups = this.groupBy(repData, 'district_name');

//     let repTotal: any = {};

//     this.subTypesName.forEach((b: any, i) => {
//       if (b.isVisible) {
//         let name = this.getKey(b.name);
//         repTotal[name + '_एकूण'] = 0;
//         repTotal[name + '_नवीन'] = 0;
//         repTotal[name + '_नूतनीकरण'] = 0;
//         repTotal[name + '_नूतनीकरणबाकी'] = 0;
//         if (i === 0) {
//           repTotal['name'] = 'प्रतिनिधी एकूण - ' + repName;
//           repTotal['sub'] = 0;
//           repTotal['एकूण'] = 0;
//           repTotal['नवीन'] = 0;
//           repTotal['नूतनीकरण'] = 0;
//           repTotal['नूतनीकरणबाकी'] = 0;
//         }
//       }
//     });

//     let repShown = false;

//     Object.keys(districtGroups).forEach(district => {
//       const districtData = districtGroups[district];
//       const talukaGroups = this.groupBy(districtData, 'taluka');

//       let districtTotal: any = {};

//       this.subTypesName.forEach((b: any, i) => {
//         if (b.isVisible) {
//           let name = this.getKey(b.name);
//           districtTotal[name + '_एकूण'] = 0;
//           districtTotal[name + '_नवीन'] = 0;
//           districtTotal[name + '_नूतनीकरण'] = 0;
//           districtTotal[name + '_नूतनीकरणबाकी'] = 0;
//           if (i === 0) {
//             districtTotal['rep_name'] = repName;
//             districtTotal['district_name'] = district;
//             districtTotal['sub'] = 0;
//             districtTotal['एकूण'] = 0;
//             districtTotal['नवीन'] = 0;
//             districtTotal['नूतनीकरण'] = 0;
//             districtTotal['नूतनीकरणबाकी'] = 0;
//           }
//         }
//       });

//       Object.keys(talukaGroups).forEach(taluka => {
//         const talukaData = talukaGroups[taluka];
//         let talukaTotal: any = {};

//         this.subTypesName.forEach((b: any, i) => {
//           if (b.isVisible) {
//             let name = this.getKey(b.name);
//             talukaTotal[name + '_एकूण'] = 0;
//             talukaTotal[name + '_नवीन'] = 0;
//             talukaTotal[name + '_नूतनीकरण'] = 0;
//             talukaTotal[name + '_नूतनीकरणबाकी'] = 0;
//             if (i === 0) {
//               talukaTotal['rep_name'] = repName;
//               talukaTotal['district_name'] = district;
//               talukaTotal['rep_taluka'] = taluka;
//               talukaTotal['sub'] = 0;
//               talukaTotal['एकूण'] = 0;
//               talukaTotal['नवीन'] = 0;
//               talukaTotal['नूतनीकरण'] = 0;
//               talukaTotal['नूतनीकरणबाकी'] = 0;
//             }
//           }
//         });

//         talukaData.forEach((a: any) => {
//           let name = this.getKey(a.subscription_type);
//           let today = new Date();
//           today.setMonth(today.getMonth() + 1);
//           let cutoffDate = formatDate(today, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');

//           // ✅ COUNT EVERY SUBSCRIBER (INCLUDING PENDING)
//           talukaTotal['sub']++;
//           districtTotal['sub']++;
//           repTotal['sub']++;
//           finalTotal['sub']++;

//           if (a['sub_perid_to_date'] > cutoffDate) {
//             if (a.rcpt_type === 'New') {
//               talukaTotal[name + '_नवीन']++;
//               districtTotal[name + '_नवीन']++;
//               repTotal[name + '_नवीन']++;
//               finalTotal[name + '_नवीन']++;
//               talukaTotal['नवीन']++;
//               districtTotal['नवीन']++;
//               repTotal['नवीन']++;
//               finalTotal['नवीन']++;
//             }
//             if (a.rcpt_type === 'Renew') {
//               talukaTotal[name + '_नूतनीकरण']++;
//               districtTotal[name + '_नूतनीकरण']++;
//               repTotal[name + '_नूतनीकरण']++;
//               finalTotal[name + '_नूतनीकरण']++;
//               talukaTotal['नूतनीकरण']++;
//               districtTotal['नूतनीकरण']++;
//               repTotal['नूतनीकरण']++;
//               finalTotal['नूतनीकरण']++;
//             }

//             const amt = parseInt(a.total_amt) || 0;
//             talukaTotal[name + '_एकूण'] += amt;
//             districtTotal[name + '_एकूण'] += amt;
//             repTotal[name + '_एकूण'] += amt;
//             finalTotal[name + '_एकूण'] += amt;
//             talukaTotal['एकूण'] += amt;
//             districtTotal['एकूण'] += amt;
//             repTotal['एकूण'] += amt;
//             finalTotal['एकूण'] += amt;
//           } else {
//             talukaTotal[name + '_नूतनीकरणबाकी']++;
//             districtTotal[name + '_नूतनीकरणबाकी']++;
//             repTotal[name + '_नूतनीकरणबाकी']++;
//             finalTotal[name + '_नूतनीकरणबाकी']++;
//             talukaTotal['नूतनीकरणबाकी']++;
//             districtTotal['नूतनीकरणबाकी']++;
//             repTotal['नूतनीकरणबाकी']++;
//             finalTotal['नूतनीकरणबाकी']++;
//           }
//         });

//         talukaTotal['showRepName'] = !repShown;
//         repShown = true;
//         this.finalData.push({ ...talukaTotal, type: 'record' });
//       });

//       districtTotal.type = 'districtTotal';
//       this.finalData.push(districtTotal);
//     });

//     repTotal.type = 'repTotal';
//     this.finalData.push(repTotal);
//   });

//   finalTotal.type = 'grandTotal';
//   this.finalData.push(finalTotal);
//   this.isLoading = false;
// }


// Helper method: group array by key
groupBy(arr: any[], key: string) {
    return arr.reduce((acc, curr) => {
        (acc[curr[key]] = acc[curr[key]] || []).push(curr);
        return acc;
    }, {});
}

setData() {

  this.finalData = [];
  let finalTotal: any = {};

  this.subTypesName.forEach((b: any, i) => {

    if (b.isVisible) {

      let name = this.getKey(b.name);

      finalTotal[name + '_एकूण'] = 0;
      finalTotal[name + '_नवीन'] = 0;
      finalTotal[name + '_नूतनीकरण'] = 0;
      finalTotal[name + '_नूतनीकरणबाकी'] = 0;

      if (i === 0) {

        finalTotal['name'] = 'एकूण';

        finalTotal['sub'] = 0;

        finalTotal['एकूण'] = 0;

        finalTotal['नवीन'] = 0;
        finalTotal['नूतनीकरण'] = 0;
        finalTotal['नूतनीकरणबाकी'] = 0;
      }
    }
  });

  const repGroups = this.groupBy(this.offrepwiseData, 'rep_name');

  Object.keys(repGroups).forEach(repName => {

    const repData = repGroups[repName];

    const districtGroups = this.groupBy(repData, 'district_name');

    let repTotal: any = {};

    this.subTypesName.forEach((b: any, i) => {

      if (b.isVisible) {

        let name = this.getKey(b.name);

        repTotal[name + '_एकूण'] = 0;
        repTotal[name + '_नवीन'] = 0;
        repTotal[name + '_नूतनीकरण'] = 0;
        repTotal[name + '_नूतनीकरणबाकी'] = 0;

        if (i === 0) {

          repTotal['name'] = 'प्रतिनिधी एकूण - ' + repName;

          repTotal['sub'] = 0;

          repTotal['एकूण'] = 0;

          repTotal['नवीन'] = 0;
          repTotal['नूतनीकरण'] = 0;
          repTotal['नूतनीकरणबाकी'] = 0;
        }
      }
    });

    let repShown = false;

    Object.keys(districtGroups).forEach(district => {

      const districtData = districtGroups[district];

      const talukaGroups = this.groupBy(districtData, 'taluka');

      let districtTotal: any = {};

      this.subTypesName.forEach((b: any, i) => {

        if (b.isVisible) {

          let name = this.getKey(b.name);

          districtTotal[name + '_एकूण'] = 0;
          districtTotal[name + '_नवीन'] = 0;
          districtTotal[name + '_नूतनीकरण'] = 0;
          districtTotal[name + '_नूतनीकरणबाकी'] = 0;

          if (i === 0) {

            districtTotal['rep_name'] = repName;
            districtTotal['district_name'] = district;

            districtTotal['sub'] = 0;

            districtTotal['एकूण'] = 0;

            districtTotal['नवीन'] = 0;
            districtTotal['नूतनीकरण'] = 0;
            districtTotal['नूतनीकरणबाकी'] = 0;
          }
        }
      });

      Object.keys(talukaGroups).forEach(taluka => {

        const talukaData = talukaGroups[taluka];

        let talukaTotal: any = {};

        this.subTypesName.forEach((b: any, i) => {

          if (b.isVisible) {

            let name = this.getKey(b.name);

            talukaTotal[name + '_एकूण'] = 0;
            talukaTotal[name + '_नवीन'] = 0;
            talukaTotal[name + '_नूतनीकरण'] = 0;
            talukaTotal[name + '_नूतनीकरणबाकी'] = 0;

            if (i === 0) {

              talukaTotal['rep_name'] = repName;
              talukaTotal['district_name'] = district;
              talukaTotal['rep_taluka'] = taluka;

              talukaTotal['sub'] = 0;

              talukaTotal['एकूण'] = 0;

              talukaTotal['नवीन'] = 0;
              talukaTotal['नूतनीकरण'] = 0;
              talukaTotal['नूतनीकरणबाकी'] = 0;
            }
          }
        });

        talukaData.forEach((a: any) => {

          let name = this.getKey(a.subscription_type);

          let today = new Date();

          today.setMonth(today.getMonth() + 1);

          let cutoffDate = formatDate(
            today,
            'yyyy-MM-dd',
            'en-IN',
            'GMT+0530'
          );

          // ✅ COUNT EVERY SUBSCRIBER
          talukaTotal['sub']++;
          districtTotal['sub']++;
          repTotal['sub']++;
          finalTotal['sub']++;

          // ✅ FIX AMOUNT
          const amt = Number(a.total_amt) || 0;

          // ✅ नवीन
          if (a.rcpt_type === 'New') {

            talukaTotal[name + '_नवीन'] =
              (talukaTotal[name + '_नवीन'] || 0) + 1;

            districtTotal[name + '_नवीन'] =
              (districtTotal[name + '_नवीन'] || 0) + 1;

            repTotal[name + '_नवीन'] =
              (repTotal[name + '_नवीन'] || 0) + 1;

            finalTotal[name + '_नवीन'] =
              (finalTotal[name + '_नवीन'] || 0) + 1;

            talukaTotal['नवीन']++;
            districtTotal['नवीन']++;
            repTotal['नवीन']++;
            finalTotal['नवीन']++;
          }

          // ✅ नूतनीकरण
          if (a.rcpt_type === 'Renew') {

            talukaTotal[name + '_नूतनीकरण'] =
              (talukaTotal[name + '_नूतनीकरण'] || 0) + 1;

            districtTotal[name + '_नूतनीकरण'] =
              (districtTotal[name + '_नूतनीकरण'] || 0) + 1;

            repTotal[name + '_नूतनीकरण'] =
              (repTotal[name + '_नूतनीकरण'] || 0) + 1;

            finalTotal[name + '_नूतनीकरण'] =
              (finalTotal[name + '_नूतनीकरण'] || 0) + 1;

            talukaTotal['नूतनीकरण']++;
            districtTotal['नूतनीकरण']++;
            repTotal['नूतनीकरण']++;
            finalTotal['नूतनीकरण']++;
          }

          // ✅ FIX:
          // amount should ALWAYS add in एकूण
          // even if pending / expired

          talukaTotal[name + '_एकूण'] =
            (talukaTotal[name + '_एकूण'] || 0) + amt;

          districtTotal[name + '_एकूण'] =
            (districtTotal[name + '_एकूण'] || 0) + amt;

          repTotal[name + '_एकूण'] =
            (repTotal[name + '_एकूण'] || 0) + amt;

          finalTotal[name + '_एकूण'] =
            (finalTotal[name + '_एकूण'] || 0) + amt;

          talukaTotal['एकूण'] =
            (talukaTotal['एकूण'] || 0) + amt;

          districtTotal['एकूण'] =
            (districtTotal['एकूण'] || 0) + amt;

          repTotal['एकूण'] =
            (repTotal['एकूण'] || 0) + amt;

          finalTotal['एकूण'] =
            (finalTotal['एकूण'] || 0) + amt;

          // ✅ ONLY PENDING COUNT
          if (a['sub_perid_to_date'] <= cutoffDate) {

            talukaTotal[name + '_नूतनीकरणबाकी'] =
              (talukaTotal[name + '_नूतनीकरणबाकी'] || 0) + 1;

            districtTotal[name + '_नूतनीकरणबाकी'] =
              (districtTotal[name + '_नूतनीकरणबाकी'] || 0) + 1;

            repTotal[name + '_नूतनीकरणबाकी'] =
              (repTotal[name + '_नूतनीकरणबाकी'] || 0) + 1;

            finalTotal[name + '_नूतनीकरणबाकी'] =
              (finalTotal[name + '_नूतनीकरणबाकी'] || 0) + 1;

            talukaTotal['नूतनीकरणबाकी']++;
            districtTotal['नूतनीकरणबाकी']++;
            repTotal['नूतनीकरणबाकी']++;
            finalTotal['नूतनीकरणबाकी']++;
          }

        });

        talukaTotal['showRepName'] = !repShown;

        repShown = true;

        this.finalData.push({
          ...talukaTotal,
          type: 'record'
        });

      });

      districtTotal.type = 'districtTotal';

      this.finalData.push(districtTotal);

    });

    repTotal.type = 'repTotal';

    this.finalData.push(repTotal);

  });

  finalTotal.type = 'grandTotal';

  this.finalData.push(finalTotal);

  this.isLoading = false;
}


  getKey(name) {
    return name.replaceAll(' ', '_');
  }

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }


 exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


   //Main Report Method Use in all Printing Page
  show = false
  printPage() {
    this.show = true
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
             <html>
                 <head>
                     <title>Print Report</title>
                     <style>
                         @media print {
                             @page { 
                                 size: A3 landscape; /* Set A3 size with landscape mode */
                                 margin: 5mm; /* Adjust margins */
                             }
                             body { 
                                 font-family: Arial, sans-serif; 
                                 font-size: 15px; /* Adjust font size */
                                 margin: 0; 
                                 padding: 5mm; 
                                 line-height: 1.2; 
                             }
                             table { 
                                 width: 100%; 
                                 height: auto !important;
                                 border-collapse: collapse; 
                                 table-layout: fixed; /* Prevent column expansion */
                                 page-break-inside: avoid; /* Avoid breaking the table */
                             }
                             th, td { 
                                 padding: 2px; 
                                 border: 1px solid black; 
                                 text-align: center; 
                                 font-size: 14px; /* Adjusted font size */
                                 line-height: 1.2; 
                             }
                             .noPrint { 
                                 display: none; /* Hide print button */
                             }
                         }
                     </style>
                 </head>
                 <body>
                     <div id="print-section">
                         ${printContent}
                     </div>
                     <script>
                         window.onload = function() { 
                             window.print(); 
                             setTimeout(() => { window.close(); }, 500);
                         };
                     </script>
                 </body>
             </html>
         `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }


}
